/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Companydetails_Directortwo2Inputs */

const ja_company_companydetails_directortwo2 = /** @type {(inputs: Company_Companydetails_Directortwo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`黄海龙（フアン ハイロング） - 取締役`)
};

const en_company_companydetails_directortwo2 = /** @type {(inputs: Company_Companydetails_Directortwo2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Huang Hailong - Director`)
};

/**
* | output |
* | --- |
* | "Huang Hailong - Director" |
*
* @param {Company_Companydetails_Directortwo2Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const company_companydetails_directortwo2 = /** @type {((inputs?: Company_Companydetails_Directortwo2Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Companydetails_Directortwo2Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_company_companydetails_directortwo2(inputs)
	return en_company_companydetails_directortwo2(inputs)
});
export { company_companydetails_directortwo2 as "company_companyDetails_directorTwo" }